import React from 'react';
import styled from 'styled-components';

// Container card
const Card = styled.div`
  width: 100%;
  max-width: 100%;
  border-radius: 16px;
  background: ${({ theme }) => theme.card};
  border: 1px solid #ece7f6;
  box-shadow: 0 10px 30px rgba(80, 40, 140, 0.06);
  padding: 18px 20px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  transition: all 0.3s ease-in-out;
  &:hover {
    box-shadow: rgba(23, 92, 230, 0.3) 0px 8px 32px;
    transform: translateY(-5px);
  }

  @media (max-width: 768px) {
    width: 90%;
    padding: 12px;
    gap: 8px;
  }
`;

// Top section with logo and role info
const Top = styled.div`
  display: flex;
  gap: 12px;
  align-items: center;
`;

// Company image/logo
const Image = styled.img`
  height: 50px;
  width: 50px;
  object-fit: cover;
  border-radius: 10px;
  background-color: #eee;

  @media (max-width: 768px) {
    height: 40px;
    width: 40px;
  }
`;

// Text container
const Body = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
`;

// Role, Company, Date
const Role = styled.div`
  font-size: 18px;
  font-weight: 600;
  color: ${({ theme }) => theme.text_primary + 'DD'};
  @media (max-width: 768px) {
    font-size: 14px;
  }
`;
const Company = styled.div`
  font-size: 14px;
  font-weight: 500;
  color: ${({ theme }) => theme.text_secondary + 'DD'};
  @media (max-width: 768px) {
    font-size: 12px;
  }
`;
const Date = styled.div`
  font-size: 12px;
  font-weight: 400;
  color: ${({ theme }) => theme.text_secondary + '88'};
  @media (max-width: 768px) {
    font-size: 10px;
  }
`;

// Description
const Description = styled.div`
  font-size: 15px;
  color: ${({ theme }) => theme.text_primary + 'CC'};
  @media (max-width: 768px) {
    font-size: 12px;
  }
`;
const Span = styled.span`
  display: -webkit-box;
  -webkit-line-clamp: 4;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
`;

// Skills section
const Skills = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 8px;
`;
const Skill = styled.div`
  font-size: 14px;
  font-weight: 400;
  color: ${({ theme }) => theme.text_primary + 'CC'};
  @media (max-width: 768px) {
    font-size: 12px;
  }
`;

// Document image
const Document = styled.img`
  height: 70px;
  width: auto;
  object-fit: cover;
  border-radius: 10px;
  margin-top: 8px;
  &:hover {
    cursor: pointer;
    opacity: 0.8;
  }
  @media (max-width: 768px) {
    height: 50px;
  }
`;

const ExperienceCard = ({ experience }) => {
  return (
    <Card>
      <Top>
        <Image src={experience.img || '/fallback.png'} alt={experience.role} />
        <Body>
          <Role>{experience.role}</Role>
          <Company>{experience.company}</Company>
          <Date>{experience.date}</Date>
        </Body>
      </Top>

      {experience.desc && (
        <Description>
          <Span>{experience.desc}</Span>
        </Description>
      )}

      {experience.skills && (
        <Skills>
          {experience.skills.map((skill, idx) => (
            <Skill key={idx}>• {skill}</Skill>
          ))}
        </Skills>
      )}

      {experience.doc && (
        <a href={experience.doc} target="_blank" rel="noreferrer">
          <Document src={experience.doc} alt="Document" />
        </a>
      )}
    </Card>
  );
};

export default ExperienceCard;
